import { Layout, Menu } from "antd";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import logoImg from "../../../Assets/Images/logo.png";
import logoSmallImg from "../../../Assets/Images/small_logo.png";
import { CustIcon } from "../../Svgs";
import "./DashboardSidebar.less";
const { REACT_APP_ASSETS_URL } = process.env;

export const DashboardSidebar = ({
  menuOptions,
  isSideBarOpen,
  toggleSideBarMenu,
  fullLogo,
  smallLogo,
}) => {
  const location = useLocation();
  return (
    <Layout.Sider
      breakpoint="xl"
      onBreakpoint={(small) => {
        if (small) {
          toggleSideBarMenu(small);
        }
      }}
      trigger={null}
      collapsedWidth="80px"
      width="240px"
      collapsible
      className="mainSidebar"
      collapsed={isSideBarOpen}
    >
      <div className="closeHamburgar" onClick={toggleSideBarMenu}>
        <span>
          {
            <CustIcon
              type="close"
              className={`${isSideBarOpen ? "" : "open"}`}
            />
          }
        </span>
      </div>
      <div className="logo">
        <Link to="/">
          <img
            src={fullLogo ? REACT_APP_ASSETS_URL + fullLogo : logoImg}
            className="big"
            alt=""
          />
        </Link>
        <Link to="/">
          <img
            src={smallLogo ? REACT_APP_ASSETS_URL + smallLogo : logoSmallImg}
            className="small"
            alt=""
          />
        </Link>
      </div>
      <Menu
        selectedKeys={[
          location.pathname === "/"
            ? "dashboard"
            : location.pathname.split("/")[1],
        ]}
      >
        {menuOptions.map(({ title, link, key, custIcon }) => (
          <Menu.Item key={key} icon={<CustIcon type={custIcon} />}>
            <Link to={link}>{title}</Link>
          </Menu.Item>
        ))}
      </Menu>
    </Layout.Sider>
  );
};
